<template>
  <div class="home-banner" :class="[deviceType]">
    <div class="banner-content">
      <div class="banner-text">
        <h1 class="banner-title">Discover the Perfect Baby Name</h1>
        <p class="banner-description">Smart, simple, and culturally rich name ideas — powered by AI.
        </p>
      </div>
      <div class="banner-actions">
        <div class="generate-button" @mouseenter="isButtonHovered = true"
          @mouseleave="isButtonHovered = false" :class="{ 'hovered': isButtonHovered }"
          @click="goToNamesPage">
          <div class="button-icon">
            <img src="@/assets/icons/generate.svg" alt="icon" />
          </div>
          <div class="button-text">Generate Names</div>
        </div>
        <div class="card-icon" @click="fetchRandomNames()" v-if="deviceType === 'mobile'">
          <img src="@/assets/icons/refresh.svg" alt="icon" />
        </div>
      </div>
    </div>
    <div class="banner-cards">
      <div class="card-column left-column" v-if="deviceType !== 'mobile'">
        <div class="card-icon" @click="fetchRandomNames()">
          <img src="@/assets/icons/refresh.svg" alt="icon" />
        </div>
      </div>
      <template v-if="deviceType === 'mobile' && hasCustomMobileHomeAdLayout">
        <template v-for="ad in mobileHomeAdsAt(0)">
          <AdComponent :key="'custom-home-mobile-' + ad.slot" v-if="getMobileHomeAdConfig(ad.slot)"
            class="home-mobile-ad ad-width-100" :ads="getMobileHomeAdConfig(ad.slot)" :showDebug="showDebug" />
        </template>
      </template>
      <div class="card-column middle-column">
        <template v-for="(card, index) in nameCards.slice(0, 2)">
          <router-link :key="index" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div"
            class="name-card" @mouseenter="setHoveredCard(index)" @mouseleave="setHoveredCard(null)"
            :class="{ 'hovered': hoveredCard === index, 'animated': true, 'animation-complete': animationsCompleted }"
            :style="{ 'animation-delay': `${index * 0.2}s` }">
            <div class="card-header">
              <div class="card-name">{{ card.name }}</div>
              <div class="card-gender-icon">
                <img :src="card.genderIcon" alt="gender" />
              </div>
            </div>
            <div class="card-pronunciation">{{ card.pronunciation }}</div>
            <div class="card-divider"></div>
            <div class="card-details">
              <div class="detail-group">
                <div class="detail-label">Style</div>
                <div class="detail-value">{{ card.style }}</div>
              </div>
              <div class="detail-group">
                <div class="detail-label">Meaning</div>
                <!-- <div class="detail-value text-ellipsis">{{ card.meaning }}</div> -->
                <div class="detail-value">
                  <span v-for="item in card.meaningList" :key="item">{{ item }}</span>
                </div>
              </div>
            </div>
            <div class="card-divider"></div>
            <div class="card-popularity">
              <div class="popularity-label">US Popularity</div>
              <div class="popularity-value">{{ card.popularity }}</div>
            </div>
          </router-link>
          <AdComponent :key="'ads-homebanner-' + index" v-if="deviceType == 'mobile' && index === 0 && !hasCustomMobileHomeAdLayout"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1" ref="ads-home-1"
            class="ad-width-100 ad-width-100" :ads="adsensConfig?.home_1" :showDebug="showDebug" />
          <template v-if="deviceType === 'mobile' && hasCustomMobileHomeAdLayout">
            <template v-for="ad in mobileHomeAdsAt(index + 1)">
              <AdComponent :key="'custom-home-mobile-' + ad.slot" v-if="getMobileHomeAdConfig(ad.slot)"
                class="home-mobile-ad ad-width-100" :ads="getMobileHomeAdConfig(ad.slot)" :showDebug="showDebug" />
            </template>
          </template>
        </template>
      </div>
      <div class="card-column right-column">
        <template v-for="(card, index) in nameCards.slice(2, 4)">
          <router-link :key="index + 2" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div" class="name-card"
            @mouseenter="setHoveredCard(index + 2)" @mouseleave="setHoveredCard(null)"
            :class="{ 'hovered': hoveredCard === index + 2, 'animated': true, 'animation-complete': animationsCompleted }"
            :style="{ 'animation-delay': `${(index + 2) * 0.2}s` }">
          <div class="card-header">
            <div class="card-name">{{ card.name }}</div>
            <div class="card-gender-icon">
              <img :src="card.genderIcon" alt="gender" />
            </div>
          </div>
          <div class="card-pronunciation">{{ card.pronunciation }}</div>
          <div class="card-divider"></div>
          <div class="card-details">
            <div class="detail-group">
              <div class="detail-label">Style</div>
              <div class="detail-value">{{ card.style }}</div>
            </div>
            <div class="detail-group">
              <div class="detail-label">Meaning</div>
              <!-- <div class="detail-value text-ellipsis">{{ card.meaning }}</div> -->
              <div class="detail-value">
                <span v-for="item in card.meaningList" :key="item">{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="card-divider"></div>
          <div class="card-popularity">
            <div class="popularity-label">US Popularity</div>
            <div class="popularity-value">{{ card.popularity }}</div>
          </div>
          </router-link>
          <template v-if="deviceType === 'mobile' && hasCustomMobileHomeAdLayout && index + 3 < 4">
            <template v-for="ad in mobileHomeAdsAt(index + 3)">
              <AdComponent :key="'custom-home-mobile-' + ad.slot" v-if="getMobileHomeAdConfig(ad.slot)"
                class="home-mobile-ad ad-width-100" :ads="getMobileHomeAdConfig(ad.slot)" :showDebug="showDebug" />
            </template>
          </template>
        </template>
      </div>
      <template v-if="deviceType === 'mobile' && hasCustomMobileHomeAdLayout">
        <template v-for="ad in mobileHomeAdsAt(4)">
          <AdComponent :key="'custom-home-mobile-' + ad.slot" v-if="getMobileHomeAdConfig(ad.slot)"
            class="home-mobile-ad ad-width-100" :ads="getMobileHomeAdConfig(ad.slot)" :showDebug="showDebug" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'HomeBanner',
  components: {
    AdComponent
  },
  data () {
    return {
      isButtonHovered: false,
      hoveredCard: null,
      animationsCompleted: false,
      nameCards: [],
      randomOptions: [
        { gender: ['Boy'] },
        { gender: ['Girl'] },
        { gender: ['Unisex'] },
        { syllables: '2' },
        { syllables: '3' }
      ],
      filterTotals: {} // To cache total counts for each filter
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'gender',
      'style',
      'meaning',
      'domainConfig',
      'showDebug',
      'adsensConfig'
    ]),
    mobileHomeAdPositions () {
      return Array.isArray(this.domainConfig?.homeMobileAdPositions)
        ? this.domainConfig.homeMobileAdPositions
        : [];
    },
    hasCustomMobileHomeAdLayout () {
      return this.mobileHomeAdPositions.length > 0;
    }
  },
  mounted () {
    // 设置动画完成状态的延迟时间
    setTimeout(() => {
      this.animationsCompleted = true;
    }, 1500); // 给所有卡片足够的时间完成动画
    this.fetchRandomNames();
  },
  methods: {
    async fetchRandomNames () {
      try {
        // 1. From 5 predefined options, randomly choose one
        const randomIndex = Math.floor(Math.random() * this.randomOptions.length);
        const randomFilter = this.randomOptions[randomIndex];
        const filterKey = JSON.stringify(randomFilter);

        // 2. Prepare base request parameters
        let params = {
          pageSize: '4',
          pageNum: '1',
          sortType: 'S_3', // Default sort by popularity
          ...randomFilter
        };

        // 3. Use cached total to determine page number for more variety
        const storedTotal = this.filterTotals[filterKey];
        if (storedTotal && storedTotal > 4) {
          const totalPages = Math.ceil(storedTotal / 4);
          if (totalPages > 1) {
            // Pick a random page, but not the last one, to increase variety
            params.pageNum = Math.floor(Math.random() * (totalPages - 1)) + 1;
          }
        }

        // Add origin from domainConfig
        if (this.domainConfig && this.domainConfig.origin) {
          params.origin = this.domainConfig.origin;
        }

        // 4. Make a single API request
        const response = await this.$global.server.postAPI({
          method: 'post',
          params: params,
          url: '/name/page',
        });

        if (response.data) {
          // 5. Cache the new total count
          this.filterTotals[filterKey] = response.data.total || 0;

          // 6. Update the name cards for display
          const list = response.data.list || [];
          if (list.length > 0) {
            this.nameCards = list.slice(0, 4).map(item => ({
              id: item.id || '',
              name: item.name || 'N/A',
              genderIcon: item.gender === 'Boy'
                ? require('@/assets/icons/male.svg')
                : item.gender === 'Unisex'
                  ? require('@/assets/icons/unsex.svg')
                  : require('@/assets/icons/female.svg'),
              pronunciation: item.pronunciation || 'N/A',
              style: item.style || 'N/A',
              meaning: item.meaning || 'N/A',
              meaningList: item.meaningList || [],
              popularity: item.popularity || 'N/A'
            }));
            console.log('Banner random names fetched successfully:', this.nameCards);
          } else if (this.nameCards.length === 0) {
            console.log('No names found for the selected filter.');
          }
        }
      } catch (error) {
        console.error('Error fetching random names for banner:', error);
      }
    },
    mobileHomeAdsAt (afterCards) {
      return this.mobileHomeAdPositions.filter(ad => Number(ad.afterCards) === afterCards && ad.slot);
    },
    getMobileHomeAdConfig (slot) {
      return this.adsensConfig?.[slot] || null;
    },
    setHoveredCard (index) {
      if (this.animationsCompleted) {
        this.hoveredCard = index;
      }
    },
    goToNamesPage () {
      this.$router.push('/names');
    }
  }
};
</script>
    <style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-banner {
	background: linear-gradient(180deg, rgba(163, 25, 132, 1) 0%, rgba(163, 25, 132, 0.6) 69.65%, rgba(163, 25, 132, 0) 100%);
	padding: 0 rem(180) rem(60) rem(180);
	display: flex;
	flex-direction: row;
	gap: rem(72);
	align-items: center;
	justify-content: flex-start;
	position: relative;

	.banner-content {
		padding: rem(120) 0;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		align-self: stretch;
		flex: 1;
		gap: rem(64);
		position: relative;

		.banner-text {
			display: flex;
			flex-direction: column;
			gap: rem(32);
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			position: relative;

			.banner-title {
				background: linear-gradient(108.74deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 100%);
				background-clip: text;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				text-align: left;
				font-size: rem(72);
				line-height: rem(80);
				font-weight: 900;
				position: relative;
				align-self: stretch;
				-webkit-text-stroke: rem(1) #ffffff;
			}

			.banner-description {
				color: #ffffff;
				text-align: left;
				font-size: rem(20);
				line-height: rem(28);
				font-weight: 400;
				position: relative;
				align-self: stretch;
			}
		}

		.generate-button {
			background: linear-gradient(92.89deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.7) 30%, rgba(255, 255, 255, 1) 100%);
			border-radius: rem(100);
			border: rem(1) solid #ffffff;
			padding: rem(20) rem(32);
			display: flex;
			flex-direction: row;
			gap: rem(16);
			align-items: center;
			justify-content: center;
			height: rem(60);
			position: relative;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			cursor: pointer;
			transition: all 0.3s ease;

			&.hovered {
				background: #ffffff;
				box-shadow: 0 rem(4) rem(8) 0 rgba(0, 0, 0, 0.16);
			}

			.button-icon {
				width: rem(28);
				height: rem(28);
				position: relative;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.button-text {
				color: #a31984;
				text-align: center;
				font-size: rem(22);
				line-height: rem(24);
				font-weight: 900;
				position: relative;
			}
		}
	}

	.banner-cards {
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: flex-start;
		justify-content: flex-end;
		position: relative;

		.card-column {
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: flex-start;
			position: relative;

			&.left-column {
				padding-top: rem(180);
				justify-content: flex-start;
				align-self: stretch;

				.card-icon {
					background: linear-gradient(92.89deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.7) 30%, rgba(255, 255, 255, 1) 100%);
					border-radius: rem(22);
					border: rem(1) solid #ffffff;
					padding: rem(12);
					display: flex;
					align-items: center;
					justify-content: center;
					width: rem(44);
					height: rem(44);
					position: relative;
					box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
					cursor: pointer;
					transition: all 0.3s ease;

					&:hover {
						background: #ffffff;
						box-shadow: 0 rem(4) rem(8) 0 rgba(0, 0, 0, 0.16);
					}

					img {
						width: rem(20);
						height: rem(20);
					}
				}
			}

			&.middle-column {
				padding-top: rem(120);
			}

			&.right-column {
				padding-top: rem(60);
				padding-bottom: rem(60);
			}
		}

		a {
			text-decoration: none;
		}

		.name-card {
			background: linear-gradient(139.77deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9) 59.95%, rgba(255, 255, 255, 0.6) 100%);
			border-radius: rem(36);
			border: rem(1) solid #ffffff;
			padding: rem(24);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
			justify-content: flex-start;
			width: rem(252);
			height: rem(274);
			position: relative;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			opacity: 0;
			transform: translateY(rem(20));
			cursor: pointer;

			&.animated {
				animation: cardFadeIn 0.5s forwards;
			}

			&.animation-complete {
				transition: background 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
			}

			&:hover,
			&.hovered {
				background: linear-gradient(139.77deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 59.95%, rgba(255, 255, 255, 1) 100%);
				box-shadow: 0 rem(4) rem(8) 0 rgba(0, 0, 0, 0.16);
				transform: translateY(rem(-2));
			}

			&:last-child {
				margin-bottom: 0;
			}

			.card-header {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.card-name {
					color: #03133a;
					text-align: left;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
				}

				.card-gender-icon {
					width: rem(16);
					height: rem(16);
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}

			.card-pronunciation {
				background: #f7f3f3;
				border-radius: rem(8);
				padding: rem(4) rem(8);
				color: #03133a;
				text-align: left;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
				font-style: italic;
				position: relative;
			}

			.card-divider {
				border-top: rem(1) dashed rgba(3, 19, 58, 0.1);
				align-self: stretch;
				height: rem(1);
				position: relative;
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(16);
				align-items: flex-start;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.detail-group {
					display: flex;
					flex-direction: column;
					gap: rem(8);
					align-items: flex-start;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.detail-label {
						color: #a31984;
						text-align: left;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 200;
						position: relative;
						align-self: stretch;
					}

					.detail-value {
						color: #03133a;
						text-align: left;
						font-size: rem(13);
						line-height: rem(14);
						font-weight: 700;
						position: relative;
						align-self: stretch;
						display: flex;
						gap: rem(7);
						&.text-ellipsis {
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}
			}

			.card-popularity {
				border-radius: rem(8);
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;

				.popularity-label {
					color: #a31984;
					text-align: left;
					font-size: rem(12);
					line-height: rem(12);
					font-weight: 200;
					position: relative;
				}

				.popularity-value {
					background: #a31984;
					border-radius: rem(8);
					padding: rem(4) rem(8);
					color: #ffffff;
					text-align: center;
					font-size: rem(14);
					line-height: rem(14);
					font-weight: 900;
					font-style: italic;
					position: relative;
				}
			}
		}
	}
}

@keyframes cardFadeIn {
	0% {
		opacity: 0;
		transform: translateY(rem(20));
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.detect_deviece_mobile {
	.home-banner {
		padding: 0 rem(16) rem(44) rem(16);
		flex-direction: column;
		gap: rem(44);

		.banner-content {
			padding: rem(44) 0 0;
			gap: rem(32);
			width: 100%;

			.generate-button {
				flex: 1;
				padding: rem(20) 0;
			}

			.banner-actions {
				display: flex;
				flex-direction: row;
				gap: rem(16);
				align-items: center;
				align-self: stretch;

				.card-icon {
					background: linear-gradient(92.89deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.7) 30%, rgba(255, 255, 255, 1) 100%);
					border-radius: rem(22);
					border: rem(1) solid #ffffff;
					padding: rem(12);
					display: flex;
					align-items: center;
					justify-content: center;
					width: rem(44);
					height: rem(44);
					box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
					cursor: pointer;
					transition: all 0.3s ease;
					flex-shrink: 0;

					&:hover {
						background: #ffffff;
						box-shadow: 0 rem(4) rem(8) 0 rgba(0, 0, 0, 0.16);
					}

					img {
						width: rem(20);
						height: rem(20);
					}
				}
			}

			.banner-text {
				gap: rem(16);

				.banner-title {
					font-size: rem(40);
					line-height: rem(48);
				}

				.banner-description {
					font-size: rem(16);
					line-height: rem(24);
				}
			}
		}

		.banner-cards {
			flex-direction: column;
			align-items: center;
			gap: rem(16);
			width: 100%;

			.card-column {
				padding: 0;
				width: 100%;

				&.middle-column,
				&.right-column {
					display: flex;
					flex-direction: column;
					gap: rem(16);
				}
			}

			.name-card {
				width: 100%;
			}
		}
	}
}
</style>